import type { Dispatch, FC, ReactNode, SetStateAction } from 'react'
import { createContext, useState } from 'react'

import { scheduleDaysDefault } from '@/constants'
import { DayBoxState, ManageType } from '@/types'

type SetStateParams<T> = Partial<T> | ((state:T)=>Partial<T>)

type SetState<T> = (arg:SetStateParams<T>)=>void

export interface ICreateScheduleContext {
  shallowSetContext: SetState<ICreateScheduleContext>
  setContext: Dispatch<SetStateAction<ICreateScheduleContext>>
  step: number
  exercises: string[]
  dayBoxes: DayBoxState[]
  manageType: ManageType
  scheduleNotes: string[]
  variant?: string
}

interface Props {
  children: ReactNode;
  variant?: string
}

const createScheduleContext = createContext({} as ICreateScheduleContext)
const CreateScheduleContextProvider = createScheduleContext.Provider

export const CreateScheduleProvider:FC<Props> = ({ children, variant = '' }) => {
  const initialValue:ICreateScheduleContext = {
    shallowSetContext: null as unknown as SetState<ICreateScheduleContext>,
    setContext: null as unknown as Dispatch<SetStateAction<ICreateScheduleContext>>,
    step: 0,
    exercises: [],
    dayBoxes: Array(scheduleDaysDefault).fill([]),
    manageType: 'week',
    scheduleNotes: [],
    variant
  }

  const [context, setContext] = useState(initialValue)

  const shallowSetContext:SetState<ICreateScheduleContext> = (val) => {
    setContext(prevState => ({
      ...prevState,
      ...val
    }))
  }

  return (
    <CreateScheduleContextProvider
      value={{ ...context, setContext, shallowSetContext }}
    >
      {children}
    </CreateScheduleContextProvider>
  )
}

export default createScheduleContext
